<!--
  대시보드 종합
  장비 토폴로지 위젯 (미사용)

  @since: 2018-05-28
  @author: mk.ko
-->

<template>
  <div ref="chartWrapper"
       class="widget-wrapper no-padding"
  >
    <div class="widget-contents">
      <div refs="topologyWrapper" class="widget-contents-wrapper">
        <ForceGraph ref="topologyInstance"
                    :autoOrbit="autoOrbit"
                    :class="{ 'is-device': isDevice }"/>
      </div>
    </div>
    <device-popup ref="devicePopup"
                  @hide="onPopupDetect" />
  </div>
</template>
<script>
  import ForceGraph from '~/plugins/forceGraph3d/forceGraph3d.vue'
  import * as THREE from 'three'

  import DeviceStatusSummaryPopup from '~/pages/dashboard/dashboard/popup/deviceStatusSummaryPopup'

  // Mixin 객체
  import { widgetMixin } from '~/mixins/widgetCommonMixin'
  // 스토어 헬퍼
  import { createNamespacedHelpers } from 'vuex'
  // 스토어 헬퍼 객체
  const storeDashboard = createNamespacedHelpers('dashboard/dashboard')
  const storeRuleObjectTrafficAnalysis = createNamespacedHelpers('policyManagement/analysis/ruleObjectTrafficAnalysis')

  import { getColorLuminance } from '~/utils/charts'

  // const top10Color = ['#1883FA', '#10EBFF', '#0061CC', '#18B8FA', '#24D6C7', '#417FB4', '#CBA8EB', '#8C80EC', '#A2B7FB', '#619DF6']
  // '#66717e'
  const top10TopologyColor = ['#11407D', '#0e6c7d', '#003c7d', '#10567d', '#197d6f', '#31587d', '#6d5a7d', '#463e7d', '#535e7d', '#31507d']
  const levelColor = ['#43CEC6', '#4c9ded', '#f5d936', '#f59b33', '#f12c40']
  const levelHexColor = [0x43CEC6, 0x4c9ded, 0xf5d936, 0xf59b33, 0xf12c40]

  export default {
    name: 'widgetDevTopology',
    components: {
      ForceGraph,
      'device-popup': DeviceStatusSummaryPopup
    },
    directives: {},
    mixins: [ widgetMixin ],
    data () {
      return {
        self: this,
        w: 3,
        title: 'widgetDevTopology',
        isLock: false,
        isMove: true,
        isResize: true,
        isMaximum: true,
        eventBus: true,
        // highlightNodes: [],
        // highlightLink: null,
        init: true,
        // White Theme
        // backgroundColor: '#ffffff',
        // linkColor: '#C4D8F1',
        // nodeColor: '#498DDA',
        // labelColor: '#000000',
        // disconnNodeColor: '#bfbfbf',
        // Dark Theme
        backgroundColor: '#061b33',
        // linkColor: '#75715E',
        prismNodeColor: '#66717e',
        linkColor: '#d0d0d0',
        nodeColor: '#0061CC',
        labelColor: '#ffffff',
        disconnNodeColor: '#6e6e6e',
        // disconnNodeColor: '#4d4d4d',
        // disconnNodeColor: '#006666',
        // disconnNodeColor: '#003333',
        // disconnNodeColor: '#001111',
        // rgba(0,255,255,0.6)
        alarmNodeColor: '#F92672',
        dimensionFlag: true, // true: 3d, false: 2d,
        topologyConfig: {},
        cameraIntervalObj: {},
        cameraDistance: 0,
        cameraAngle: 0,
        cameraRotationOrg: {},
        camera: {},
        menuCameraOrbitIcon: '',
        menuCameraOrbitLabel: '',

        selectedNode: {},
        isDevice: false,
        isConnTreeMode: false,
        autoOrbit: true,
        alarmTimer: undefined,

        prismNodeInfo: {},
        deviceIdHashMap: {},
        graphData: [],
        // environmentAnimateObject: undefined

        hidden: 'hidden',
        currentlyVisible: true
      }
    },
    computed: {
      ...storeRuleObjectTrafficAnalysis.mapGetters([
        'devicesTreeData'
      ]),
      widgetCustomMenu () {
        return [
          // {
          //   key: 'menu_dimension',
          //   icon: '3d_rotation',
          //   label: this.$t('dash.toggleDimension'),
          //   click: this.onToggleDimension
          // },
          {
            key: 'menu_modeConnTree',
            icon: 'device_hub',
            label: this.$t('dash.toggleViewMode'),
            click: this.toggleHierarchyView
          },
          {
            key: 'menu_cameraOrbitStart',
            // icon: 'play_circle_outline',
            icon: '360',
            label: this.$t('dash.cameraRotation'),
            click: this.cameraRotation
          },
          {
            key: 'menu_cameraOrbitStop',
            icon: 'pause_circle_outline',
            label: this.$t('dash.cameraRotationStop'),
            click: this.cameraRotationStop
          },
          {
            key: 'menu_cameraFocusReset',
            icon: 'center_focus_weak',
            label: this.$t('dash.cameraFocusReset'),
            click: this.cameraFocusReset
          }
        ]
      }
    },
    methods: {
      ...storeDashboard.mapActions([
        'getPrismWidgetData'
      ]),
      ...storeRuleObjectTrafficAnalysis.mapActions([
        'getDevicesTreeData'
      ]),
      nodeVal (node) {
        return node.size
      },
      nodeLabel (node) {
        let res = ''
        if (typeof node.name !== 'undefined') {
          let nodeTypeClass, nodeTypeText
          switch (node.type) {
            case 0:
              nodeTypeClass = 'label-0'
              nodeTypeText = 'TAMS'
              break
            case 1:
              nodeTypeClass = 'label-4'
              nodeTypeText = '그룹'
              break
            case 2:
              nodeTypeClass = 'label-5'
              nodeTypeText = '장비'
              break
          }

          let disconn = '',
            alarm = ''

          if (node.hasOwnProperty('disconn') && node['disconn'] === 1) {
            disconn = `<span class="device-disconn">(${this.$t('da.topology_disconnected')}</span>`
          }
          if (node.hasOwnProperty('alarm') && node.alarm > 1) {
            // warning
            const level = node.alarm - 1
            const bgColor = levelColor[level]
            const color = getColorLuminance(bgColor)
            let levelText = ''
            switch (Number(node.alarm)) {
              case 1:
                // levelText = this.$t('dash.normal')
                levelText = 'Info'
                break
              case 2:
                // levelText = this.$t('dash.attention')
                levelText = 'Low'
                break
              case 3:
                // levelText = this.$t('dash.caution')
                levelText = 'Medium'
                break
              case 4:
                // levelText = this.$t('dash.warning')
                levelText = 'High'
                break
              case 5:
                // levelText = this.$t('dash.critical')
                levelText = 'Critical'
                break
              default:
                levelText = this.$t('cmn.unknown')
            }
            alarm = `
              <span class="device-alarm" style="color: #f83030;">
                ${this.$t('da.topology_failureOccurred')} <span class="badge" style="background-color: ${bgColor}; color: ${color}">${levelText}</span>
              </span>
            `
            // <span class="pull-right badge" style="background-color: ${color}">
            //   <i class="material-icons">report_problem</i>
            // </span>)
          }

          res = `
            <div class="device-tooltip">
              <span class="device-hierarchy">${node.hasOwnProperty('hierarchyLabel') ? node.hierarchyLabel : this.$t('cmn.currentEquipment')}</span>
              <div>
                <span class="device-type label ${nodeTypeClass}">${nodeTypeText}</span>
                <span class="device-name"> ${node.name}</span>
                ${disconn}
                ${alarm}
              </div>
            </div>
          `
        } else if (typeof node.id !== 'undefined') {
          res = node.id
        }
        return res
      },
      nodeLabelColor () {
        return this.labelColor
      },
      nodeThreeObject (node) {
        // const nodeSize = node.size || 1
        const size = 8
        let mesh

        // node.type (0: Prism, 1: Gruop, 2: Node)

        switch (node.type) {
          // Prism
          case 0:
            // const prismSize = size + ((7 - node.depth) * 1.3)

            const prismSize = (size + 8) * 1
            this.prismNodeInfo.size = prismSize
            mesh = new THREE.Mesh(
              // new THREE.OctahedronGeometry(prismSize), // 팔면체
              // new THREE.TetrahedronBufferGeometry(prismSize), // 사면체
              // new THREE.SphereGeometry(prismSize, 32, 32), // 구
              new THREE.IcosahedronGeometry(prismSize, 1),
              new THREE.MeshPhongMaterial({
                // color: 0xffffff,
                color: this.prismNodeColor,
                flatShading: true,
                transparent: true,
                opacity: 0.95
              })
              // new THREE.MeshPhongMaterial({
              //   // color: this.nodeColor,
              //   // color: 0xffffff, // 완전 백색은 광원이 안먹음
              //   // color: '#0061CC',
              //   // color: this.prismNodeColor, // '#66717e',
              //   // color: 0xbfbfbf,
              //   // color: 0x202123,
              //   // color: '#000000',
              //   color: 0xffffff,
              //   flatShading: true
              //   // transparent: true,
              //   // opacity: 0.95,
              //   // shininess: 80
              //   // ambient: '#ffffff',
              //   // emissive: 0x111111,
              //   // specular: 0xbbbbbb
              // })
            )
            this.prismNodeInfo.mesh = mesh
            break

          // Group
          case 1:
            const groupSize = (size + ((8 - node.depth))) * 0.6
            mesh = new THREE.Mesh(
              // new THREE.SphereGeometry(groupSize, 32, 32),
              new THREE.SphereGeometry(groupSize, 32, 32),
              new THREE.MeshPhongMaterial({
                // color: this.nodeColor,
                // color: top10TopologyColor[9],
                // flatShading: true,
                transparent: true,
                opacity: 0.95,
                shininess: 80,
                // color: '#000000',
                color: top10TopologyColor[node.id % top10TopologyColor.length]
                // ambient: top10TopologyColor[9],
                // ambient: top10TopologyColor[node.id % 10],
                // emissive: 0x111111,
                // specular: 0xbbbbbb
              })
            )
            break

          // Node
          case 2:
            // let nodeColor
            const nodeSize = size + 1

            // const fnNodeColor = (node) => {
            //   let nodeColor
            //
            //   if (node.hasOwnProperty('alarm') && node.alarm > 1) {
            //     // nodeColor = node.color || this.alarmNodeColor
            //     nodeColor = this.alarmNodeColor
            //   } else if (node.hasOwnProperty('disconn')) {
            //     nodeColor = this.disconnNodeColor
            //   } else {
            //     nodeColor = node.color || this.nodeColor
            //     // nodeColor = this.nodeColor
            //   }
            //
            //   return nodeColor
            // }

            mesh = new THREE.Mesh(
              // new THREE.BoxGeometry(nodeSize * 3, nodeSize * 2, nodeSize),
              new THREE.BoxGeometry(nodeSize, nodeSize, nodeSize),
              new THREE.MeshPhongMaterial({
                // flatShading: true,
                transparent: true,
                opacity: (node.hasOwnProperty('disconn') && node['disconn'] === 1) ? 0.3 : 0.95,
                wireframe: (node.hasOwnProperty('disconn') && node['disconn'] === 1),
                shininess: 80,
                color: node.color || this.nodeColor
                // color: '#000000',
                // color: nodeColor
                // color: fnNodeColor(node)
                // color: this.alarmNodeColor
                // ambient: nodeColor,
                // emissive: 0x111111,
                // specular: 0xbbbbbb
              })
            )
            break
        }

        return mesh
        // const normalMesh = new THREE.Mesh(
        //   new THREE.BoxGeometry(size, size, size),
        //   new THREE.MeshPhongMaterial({
        //     color: node.color || this.nodeColor,
        //     flatShading: true
        //   })
        //   // new THREE.MeshBasicMaterial({
        //   //   color: node.color || this.nodeColor,
        //   //   transparent: true,
        //   //   opacity: 0.9
        //   // })
        //   // new THREE.MeshLambertMaterial({
        //   //   color: node.color || this.nodeColor,
        //   //   transparent: true,
        //   //   opacity: 0.9
        //   // })
        // )

        // const alarmMesh = new THREE.Mesh(
        //   new THREE.BoxGeometry(size, size, size),
        //   new THREE.MeshPhongMaterial({
        //     color: node.color || this.alarmNodeColor,
        //     flatShading: true
        //   })
        //   // new THREE.MeshBasicMaterial({
        //   //   color: this.alarmNodeColor,
        //   //   transparent: true,
        //   //   opacity: 0.9
        //   // })
        //   // new THREE.MeshLambertMaterial({
        //   //   color: this.alarmNodeColor,
        //   //   transparent: true,
        //   //   opacity: 0.9
        //   // })
        // )
        // const disconnMesh = new THREE.Mesh(
        //   new THREE.BoxGeometry(size, size, size),
        //   new THREE.MeshPhongMaterial({
        //     color: this.disconnNodeColor,
        //     flatShading: true
        //   })
        //   // new THREE.MeshBasicMaterial({
        //   //   color: this.disconnNodeColor,
        //   //   transparent: true,
        //   //   opacity: 0.9
        //   // })
        //   // new THREE.MeshLambertMaterial({
        //   //   color: this.disconnNodeColor,
        //   //   transparent: true,
        //   //   opacity: 0.9
        //   // })
        // )

        // return new THREE.Mesh(
        //   new THREE.BoxGeometry(size, size, size),
        //   new THREE.MeshBasicMaterial({
        //     color: node.color || this.nodeColor,
        //     transparent: true,
        //     opacity: 0.9
        //   })
        //   // new THREE.MeshLambertMaterial({
        //   //   color: node.color || '#ffffff',
        //   //   transparent: true,
        //   //   opacity: 1
        //   // })
        // )
      },
      // linkWidth (link) {
      //   return link === this.highlightLink ? 5 : 2
      // },
      lineMaterial (link) {
        const group = parseInt(link.target)
        const color = (group === 1) ? this.prismNodeColor : top10TopologyColor[group % top10TopologyColor.length] || this.linkColor
        // return new THREE.MeshBasicMaterial({
        //   // color: this.linkColor
        //   color: top10TopologyColor[group % 10]
        // })
        // this.$log('### linkMaterial.link', JSON.stringify(link))
        // this.$log('### linkMaterial.group', group)
        // this.$log('### linkMaterial.color', color)
        return new THREE.MeshPhongMaterial({
          // color: this.linkColor,
          color: color,
          // flatShading: true,
          transparent: true,
          // opacity: 0.3,
          opacity: 0.4,
          // emissive: 0x111111,
          // specular: 0xbbbbbb,
          shininess: 80
        })
      },
      onNodeClick (node) {
        if (node.type === 2) {
          // if (typeof node.x === 'undefined' || typeof node.y === 'undefined' || typeof node.z === 'undefined') {
          //   const pos = node.__threeObj.position
          //   node.x = pos.x
          //   node.y = pos.y
          //   node.z = pos.z
          // }
          // this.$refs.topologyInstance.cameraPosition({ x: node.x + 20, y: node.y + 20, z: node.z + 20 }, node)
          //
          // this.selectedNode = node
          // this.cameraRotationStop()
          // this.$refs.devicePopup.show(node)
          // this.cameraRotationStop()

          const graph = this.$refs.topologyInstance.getGraphInstance()
          const distance = 40
          const distRatio = 1 + distance / Math.hypot(node.x, node.y, node.z)
          const duration = 1000
          this.autoOrbit = false

          const self = this.self
          setTimeout(() => {
            self.$refs.devicePopup.show(node)
          }, duration)

          graph.cameraPosition(
            { x: node.x * distRatio, y: node.y * distRatio, z: node.z * distRatio }, // new position
            void 0, // lookAt ({ x, y, z }) // NODE 넣으면 hierarchy 에 null이 들어가는 현상 발생됨 (1.41.1 업데이트 이후)
            duration // ms transition duration
          )
        }
      },
      onNodeHover (node) {
        // this.highlightNodes = node ? [node] : []
        let isDevice = false
        if (node !== null) {
          if (node.type === 2) {
            isDevice = true
          }
        }
        this.isDevice = isDevice
      },
      // onLinkHover (link) {
      //   if (this.highlightLink === link) return
      //   this.highlightLink = link
      //   this.highlightNodes = link ? [link.source, link.target] : []
      // },
      render (config) {
        this.$refs.topologyInstance.render(config)
      },
      afterRenderInitEvent () {
        // 알람 장비 해시맵
        this.makeDeviceIdHashMap()

        // this.$log('### node data.PRISM', data.nodes[0])
        // setTimeout(() => {
        //   const prismNode = data.nodes[0]
        //   const graph = this.$refs.topologyInstance.getGraphInstance()
        //   const distance = 1000
        //   const distRatio = 1 + distance / Math.hypot(prismNode.x, prismNode.y, prismNode.z)
        //
        //   graph.cameraPosition(
        //     { x: prismNode.x * distRatio, y: prismNode.y * distRatio, z: prismNode.z * distRatio }, // new position
        //     prismNode // lookAt ({ x, y, z })
        //   )
        // }, 3000)

        this.alarmFlashColor()

        // TODO: 마우스 움직임 캡쳐, 멈춤/동작 기능 이후 추가 할 것
        // 카메라 로테이션 추가
        this.cameraRotation()

        // Prism 노드 포커싱
        // const prismNode = data.nodes.find(row => {
        //   return row.id === '1'
        // })
        // this.$refs.topologyInstance.cameraPosition({ x: prismNode.x + 40, y: prismNode.y + 40, z: prismNode.z + 40 }, prismNode)
      },
      // Mixin - Basic 데이터
      async getWidgetContentsData () {
        const self = this.self
        // Browser Active 상태에서만 리로딩됨 (비하인드 상태에서, 노드간격 줄어드는 현상 대응)
        // 발생될때, window 로그아웃 상태일 경우
        if (self.currentlyVisible) {
          // Progress 출력 여부
          this.showProgress(true)

          let currentOptions = {
            widgetType: 'dash_overall_topology'
          }

          // const data = await this.getPrismWidgetData(currentOptions)
          this.graphData = await this.getPrismWidgetData(currentOptions)

          const item = []
          this.graphData.nodes.forEach(node => {
            // Prism 노드 고정
            if (node.type === 0) {
              // node.vx = node.vy = node.vz = 0
              node.fx = node.fy = node.fz = 0
            }
            if (this.isHierarchyTreeMode) {
              node.fx = (node.type === 0) ? node.fx : node.depth * 40
              // node.fy = 0
              // node.fz = node.depth * -30
            }

            item[node.id] = node
          })

          // 계층관계 데이터 주입
          this.graphData.links.forEach((link, idx) => {
            const child = item[link.source]
            const parent = item[link.target]

            if (parent.hasOwnProperty('hierarchy')) {
              child.hierarchy = _.cloneDeep(parent.hierarchy).concat([{id: parent.id, label: parent.name}])
              child.hierarchyLabel = `${parent.hierarchyLabel} <i class="material-icons">chevron_right</i> ${parent.name}`
            } else {
              child.hierarchy = [{id: parent.id, label: parent.name}]
              child.hierarchyLabel = parent.name
            }
          })

          if (this.init) {
            const config = {
              // graphData: this.getData(),
              graphData: this.graphData,
              width: this.$refs.chartWrapper.clientWidth,
              height: this.$refs.chartWrapper.clientHeight,
              // forceEngine: 'ngraph',
              forceEngine: 'd3',
              numDimensions: 3,
              // backgroundColor: this.backgroundColor,
              // backgroundColor: 'transparent', // warning 에러는 발생됨 THREE.color 관련 (1.41.1 업데이트 이후 렌더링 자체가 안됨)
              backgroundColor: 'rgba(0, 0, 0, 0)',
              nodeLabel: this.nodeLabel,
              // nodeLabelColor: this.nodeLabelColor,
              nodeRelSize: 4,
              nodeVal: this.nodeVal,
              nodeOpacity: 1,
              nodeThreeObject: this.nodeThreeObject,
              onNodeHover: this.onNodeHover,
              // linkWidth: this.linkWidth,
              linkWidth: 2,
              // linkColor: this.linkColor,
              // linkColor: this.lineColor,
              linkMaterial: this.lineMaterial,
              // linkDirectionalArrowLength: 3.5,
              // linkDirectionalArrowRelPos: 1,
              // linkDirectionalParticles: 'value',
              // linkDirectionalParticleSpeed: 1,
              // linkDirectionalParticles: link => link === this.highlightLink ? 4 : 0,
              // linkDirectionalParticleWidth: 4,
              // linkCurvature: 0.25,
              // onLinkHover: this.onLinkHover,
              onNodeClick: this.onNodeClick,
              enableNodeDrag: false
              // d3AlphaDecay: 0,
              // d3VelocityDecay: 0
              // cooldownTicks: 0
              // cooldownTime: 0
            }
            this.topologyConfig = config
            this.render(config)
            setTimeout(() => {
              // 광원 추가
              this.addLight() // 한 번 만
              self.afterRenderInitEvent()
              self.init = false
            }, 0)
          } else {
            // const data = this.getData()
            this.redrawChart(this.graphData)
            setTimeout(() => {
              self.afterRenderInitEvent()
            }, 0)
          }

          // Progress 출력 여부
          this.showProgress(false)
          // setTimeout(() => {
          //   this.showProgress(false)
          // }, 1500)
        }
      },
      resizeChart () {
        const width = this.$refs.chartWrapper.clientWidth
        const height = this.$refs.chartWrapper.clientHeight
        this.$refs.topologyInstance.onResize(width, height)
        this.cameraFocusReset()
      },
      // resizeChart () {
      //   this.$refs.topologyInstance.onResize()
      //   this.cameraFocusReset()
      // },
      redrawChart (...args) {
        this.$refs.topologyInstance.redrawGraph(...args)
        this.cameraFocusReset()
        // this.cameraFocusNode()
      },
      // 2D/3D 토글
      onToggleDimension () {
        const flag = this.dimensionFlag = !this.dimensionFlag

        if (flag) {
          this.$refs.topologyInstance.onChangeDimension(3)
        } else {
          this.$refs.topologyInstance.onChangeDimension(2)
        }
      },
      cameraRotation () {
        this.autoOrbit = true
        // this.$refs.topologyInstance.cameraOrbitStart()
      },
      cameraRotationStop () {
        this.autoOrbit = false
        this.$refs.topologyInstance.cameraOrbitStop()
      },
      cameraFocusReset () {
        this.$refs.topologyInstance.cameraFocusReset()
      },
      // cameraFocusNode (id = '1', distance = 40) {
      //   const graph = this.$refs.topologyInstance.getGraphInstance()
      //   const graphData = graph.graphData()
      //   let prismNode = graphData.nodes.find(node => {
      //     return node.id === id
      //   })
      //   prismNode.x = prismNode.__threeObj.position.x
      //   prismNode.y = prismNode.__threeObj.position.y
      //   prismNode.z = prismNode.__threeObj.position.z
      //   this.$refs.topologyInstance.cameraPosition({ x: prismNode.x + distance, y: prismNode.y + distance, z: prismNode.z + distance }, prismNode)
      // },
      // TODO: 추후 성능 개선은 필요함.
      alarmFlashColor () {
        if (typeof this.alarmTimer !== 'undefined') {
          clearTimeout(this.alarmTimer)
        }

        // const self = this.self
        // const alarmColor = _.clone(self.alarmNodeColor)
        // const disconnColor = _.clone(self.disconnNodeColor)
        // const nodeColor = _.clone(self.nodeColor)

        const changeDeviceNodeColor = (id, color) => {
          // this.$log('### changeColor.id', id)
          // this.$log('### changeColor.color', color)
          // this.$log('### changeColor.this.deviceIdHashMap', this.deviceIdHashMap)
          if (typeof this.deviceIdHashMap[id] !== 'undefined') {
            this.deviceIdHashMap[id].__threeObj.material.color.setHex(color)
          }
        }

        const alarmTimer = () => {
          this.graphData.nodes.forEach(node => {
            if (node.type === 2) {
              const disconnColor = 0x6e6e6e
              const nodeColor = 0x0061cc
              if (node.hasOwnProperty('alarm') && node.alarm > 1) {
                const level = node.alarm - 1
                const alarmColor = levelHexColor[level]
                node.color = (node.color === alarmColor) ? nodeColor : alarmColor
              } else {
                node.color = (node.hasOwnProperty('disconn') && node['disconn'] === 1) ? disconnColor : nodeColor
              }
              changeDeviceNodeColor(node.id, node.color)
            }
          })

          this.alarmTimer = setTimeout(alarmTimer, 1000)
        }

        alarmTimer()

        // hashMap[10].__threeObj.material.color.setHex(0x000000)

        /* ===========================
         * 성능 개선 전 (백업)
         * =========================== */

        // // const graph = this.$refs.topologyInstance.getGraphInstance()
        // // // const { nodes, links } = graph.graphData()
        // // graph.nodeThreeObject(node => this.nodeThreeObject)
        // if (typeof this.alarmTimer !== 'undefined') {
        //   clearTimeout(this.alarmTimer)
        // }
        // const self = this.self
        // // const alarmColor = _.clone(self.alarmNodeColor)
        // const disconnColor = _.clone(self.disconnNodeColor)
        // const nodeColor = _.clone(self.nodeColor)
        // // let flag = true
        //
        // const graph = this.$refs.topologyInstance.getGraphInstance()
        //
        // const alarmTimer = () => {
        //   this.graphData.nodes.forEach(node => {
        //     if (node.hasOwnProperty('alarm') && node.alarm > 1) {
        //       const level = node.alarm - 1
        //       const alarmColor = levelColor[level]
        //       node.color = (node.color === alarmColor) ? nodeColor : alarmColor
        //     } else {
        //       node.color = (node.hasOwnProperty('disconn') && node['disconn'] === 1) ? disconnColor : nodeColor
        //     }
        //   })
        //
        //   graph.graphData(this.graphData)
        //
        //   this.alarmTimer = setTimeout(alarmTimer, 1000)
        // }
        //
        // alarmTimer()
        //
        // // this.alarmTimer = setInterval(() => {
        // //   if (flag) {
        // //     self.alarmNodeColor = alarmColor
        // //     self.disconnNodeColor = disconnColor
        // //   } else {
        // //     self.alarmNodeColor = nodeColor
        // //     self.disconnNodeColor = nodeColor
        // //   }
        // //   flag = !flag
        // //   this.$log('### flashAlarm.self.alarmNodeColor', self.alarmNodeColor)
        // //   this.$log('### flashAlarm.self.disconnNodeColor', self.disconnNodeColor)
        // // }, 500)
      },
      addLight () {
        const graph = this.$refs.topologyInstance.getGraphInstance()
        const scene = graph.scene()
        // this.$log('### scene.first', scene.getObjectByName('objectName', true))
        // this.$log('### scene.first', graph.nodeId(''))
        // this.$log('### scene.first', scene.getObjectByName('MF2 2', true))
        // graph.graphData()

        scene.add(new THREE.AmbientLight(0x999999))
        //
        // let backLight = new THREE.PointLight(0xffffff, 0.9)
        // backLight.position.set(100, 100, -200)
        // scene.add(backLight)
        //
        // let spotLight = new THREE.SpotLight(0xffffff)
        // spotLight.position.set(-250, 250, 250)
        // spotLight.castShadow = true
        // spotLight.shadow = new THREE.LightShadow(new THREE.PerspectiveCamera(50, 1, 250, 250))
        // spotLight.shadow.bias = 0.001
        // spotLight.shadow.mapSize.width = this.$refs.chartWrapper.clientWidth
        // spotLight.shadow.mapSize.height = this.$refs.chartWrapper.clientHeight
        // scene.add(spotLight)

        // let light = new THREE.SpotLight(0xffffff, 1, 0, Math.PI / 2)
        // // light.position.set(0, 1500, 1000)
        // light.position.set(-250, 250, 250)
        // // light.target.position.set(0, 0, 0)
        // light.castShadow = true
        // light.shadow = new THREE.LightShadow(new THREE.PerspectiveCamera(50, 1, 1000, 2500))
        // light.shadow.bias = 0.001
        // light.shadow.mapSize.width = this.$refs.chartWrapper.clientWidth
        // light.shadow.mapSize.height = this.$refs.chartWrapper.clientHeight
        // scene.add(light)

        let lights = []
        lights[0] = new THREE.DirectionalLight(0xffffff, 1)
        lights[0].position.set(1, 0, 0)
        lights[1] = new THREE.DirectionalLight(0x11E8BB, 1)
        lights[1].position.set(0.75, 1, 0.5)
        lights[2] = new THREE.DirectionalLight(0x8200C9, 1)
        lights[2].position.set(-0.75, -1, 0.5)
        scene.add(lights[0])
        scene.add(lights[1])
        scene.add(lights[2])

        let particle = new THREE.Object3D()
        let skelet = new THREE.Object3D()
        scene.add(particle)
        scene.add(skelet)

        const geom2 = new THREE.IcosahedronGeometry(2, 1)

        const geometry = new THREE.TetrahedronGeometry(1, 0)
        const material = new THREE.MeshPhongMaterial({
          color: 0xffffff,
          flatShading: true
          // shading: THREE.FlatShading
        })

        const mat2 = new THREE.MeshPhongMaterial({
          color: 0xffffff,
          wireframe: true,
          side: THREE.DoubleSide
        })

        for (let i = 0; i < 1000; i++) {
          let mesh = new THREE.Mesh(geometry, material)
          mesh.position.set(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).normalize()
          mesh.position.multiplyScalar(90 + (Math.random() * 700))
          mesh.rotation.set(Math.random() * 2, Math.random() * 2, Math.random() * 2)
          particle.add(mesh)
        }

        const planet2 = new THREE.Mesh(geom2, mat2)

        // this.$log('### scale', JSON.stringify(this.prismNodeInfo.mesh.scale))

        // 원래 값 10 이었음
        planet2.scale.x = planet2.scale.y = planet2.scale.z = 10
        // planet2.scale.x = this.prismNodeInfo.mesh.scale.x
        // planet2.scale.y = this.prismNodeInfo.mesh.scale.y
        // planet2.scale.z = this.prismNodeInfo.mesh.scale.z

        skelet.add(planet2)

        // const renderer = graph.renderer()
        // const camera = graph.camera()
        //
        // const animate = () => {
        //   this.environmentAnimateObject = requestAnimationFrame(animate)
        //   this.$log('### animate!')
        //   particle.rotation.x += 0.0000
        //   particle.rotation.y -= 0.0040
        //   skelet.rotation.x -= 0.0010
        //   skelet.rotation.y += 0.0020
        //   renderer.clear()
        //
        //   renderer.render(scene, camera)
        // }
      },
      toggleHierarchyView () {
        this.isHierarchyTreeMode = !this.isHierarchyTreeMode
        // if (typeof this.alarmTimer !== 'undefined') {
        //   clearTimeout(this.alarmTimer)
        // }
        this.getWidgetContentsData()
        this.cameraFocusReset()
      },
      onPopupDetect () {
        this.autoOrbit = true
      },
      makeDeviceIdHashMap () {
        // const graph = this.$refs.topologyInstance.getGraphInstance()
        // const scene = graph.scene()
        // this.$log('### scene.first', scene.getObjectByName('objectName', true))
        // this.$log('### scene.first', graph.nodeId(''))
        // this.$log('### scene.first', scene.getObjectByName('MF2 2', true))
        // const graphData = graph.graphData()

        this.graphData.nodes.forEach(node => {
          this.deviceIdHashMap[node.id] = node
        })

        // // hashMap[10]
        //
        // this.$log('### scene.first', scene.getObjectById('10'))
        //
        // // const graphData = graph.graphData()
        // // this.$log('### 10번', graphData.nodes[10])
        // // const tenMesh = graphData.nodes[10]
        // // tenMesh.__threeObj = this.prismNodeInfo.mesh
        // setTimeout(() => {
        //   // tenMesh.__threeObj.material.color.setHex(0x000000)
        //   hashMap[10].__threeObj.material.color.setHex(0x000000)
        //   // tenMesh.__threeObj.material = new THREE.MeshPhongMaterial({
        //   //   // color: 0xffffff,
        //   //   color: 0x000000,
        //   //   flatShading: true,
        //   //   transparent: true,
        //   //   opacity: 0.95
        //   // })
        // }, 3000)
      },

      /* ==============================
       * Browser Active Check
       * ============================== */
      initBrowserActiveCheck () {
        this.hidden = 'hidden'
        this.currentlyVisible = true
      },
      addBrowserActiveCheck () {
        // Standards:
        if (this.hidden in document) {
          document.addEventListener('visibilitychange', this.onBrowserChange)
        } else if ((this.hidden = 'mozHidden') in document) {
          document.addEventListener('mozvisibilitychange', this.onBrowserChange)
        } else if ((this.hidden = 'webkitHidden') in document) {
          document.addEventListener('webkitvisibilitychange', this.onBrowserChange)
        } else if ((this.hidden = 'msHidden') in document) {
          document.addEventListener('msvisibilitychange', this.onBrowserChange)
        } else if ('onfocusin' in document) {
          // IE 9 and lower:
          document.onfocusin = this.onBrowserShow
          document.onfocusout = this.onBrowserHide
        } else {
          // All others:
          window.onpageshow = window.onfocus = this.onBrowserShow
          window.onpagehide = window.onblur = this.onBrowserHide
        }
      },
      removeBrowserActiveCheck () {
        // Standards:
        if (this.hidden in document) {
          document.removeEventListener('visibilitychange', this.onBrowserChange)
        } else if ((this.hidden = 'mozHidden') in document) {
          document.removeEventListener('mozvisibilitychange', this.onBrowserChange)
        } else if ((this.hidden = 'webkitHidden') in document) {
          document.removeEventListener('webkitvisibilitychange', this.onBrowserChange)
        } else if ((this.hidden = 'msHidden') in document) {
          document.removeEventListener('msvisibilitychange', this.onBrowserChange)
        } else if ('onfocusin' in document) {
          // IE 9 and lower:
          document.onfocusin = undefined
          document.onfocusout = undefined
        } else {
          // All others:
          window.onpageshow = window.onfocus = undefined
          window.onpagehide = window.onblur = undefined
        }
      },
      onBrowserChange (evt) {
        // occurs both on leaving and on returning
        this.currentlyVisible = !this.currentlyVisible
        this.doSomethingIfAppropriate()
      },

      onBrowserShow (evt) {
        // for older browsers
        this.currentlyVisible = true
        this.doSomethingIfAppropriate()
      },

      onBrowserHide (evt) {
        // for older browsers
        this.currentlyVisible = false
        this.doSomethingIfAppropriate()
      },

      doSomethingIfAppropriate () {
        if (this.currentlyVisible) {
          // trigger angular digest cycle in this scope
          // Show
        } else {
          // Hide
        }
      }
    },
    beforeCreate () {},
    created () {
      window.addEventListener('resize', this.resizeChart)
    },
    beforeMount () {},
    mounted () {
      this.initBrowserActiveCheck()
      this.addBrowserActiveCheck()
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeChart)
      if (typeof this.alarmTimer !== 'undefined') {
        clearTimeout(this.alarmTimer)
      }
      // if (typeof this.environmentAnimateObject !== 'undefined') {
      //   cancelAnimationFrame(this.environmentAnimateObject)
      // }

      this.removeBrowserActiveCheck()

      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    watch: {
      // '$refs.chartWrapper.clientWidth' () {
      //   const width = this.$refs.chartWrapper.clientWidth
      //   const height = this.$refs.chartWrapper.clientHeight
      //   this.resizeChart(width, height)
      // }
    }
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    /*background: #11e8bb; !* Old browsers *!*/
    /*background: -moz-linear-gradient(top,  #11e8bb 0%, #8200c9 100%); !* FF3.6-15 *!*/
    /*background: -webkit-linear-gradient(top,  #11e8bb 0%,#8200c9 100%); !* Chrome10-25,Safari5.1-6 *!*/
    /*background: linear-gradient(to bottom,  #11e8bb 0%,#8200c9 100%); !* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ *!*/
    /*filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#11e8bb', endColorstr='#8200c9',GradientType=0 ); !* IE6-9 *!*/
    /*background: #133c7d; !* Old browsers *!*/
    background: #061b33; /* Old browsers */
    background: -moz-linear-gradient(top,  #061b33 0%, #133c7d 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, #061b33 0%, #133c7d 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom,  #061b33 0%,#133c7d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#061b33', endColorstr='#133c7d',GradientType=0 ); /* IE6-9 */
  }

  .widget-wrapper.no-padding {
    padding: 0 0 !important;
  }

  .widget-contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
  }

  .widget-contents-chart {
    flex-grow: 1;
  }
  .is-device {
    cursor: pointer;
  }

</style>
